import React from 'react';
import { 
  Button, 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogContentText,
  DialogTitle,
  Divider,
  makeStyles,
  Grid
} from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  paper: {
    minWidth: "30vw",
    padding: "2vh 2vw"
  },
  title: {
    fontWeight: "bold",
    fontSize: "1.25rem",
    color: theme.palette.primary.main,
    marginBottom: 20
  },
  body: {
    ...theme.typography.body1,
    textAlign: "center",
    margin: "25px 0px"
  },
  alert: {
    color: theme.palette.warning.dark
  },
  error: {
    color: theme.palette.error.main
  },
  success: {
    color: theme.palette.success.dark
  },
  button: {
    ...theme.typography.body1,
    backgroundColor: theme.palette.grey.main,
    color: theme.palette.primary.contrastText,
    textTransform: "capitalize", 
    minWidth:180,
    minHeight: 50
  },
  buttonOutlined: {
    ...theme.typography.body1,
    border: "2px solid",
    textTransform: "capitalize", 
    minWidth:180,
    minHeight: 50
  }, 
}));

const DialogCustom = ({ 
  open, 
  handleClose, 
  handleChange, 
  title, 
  body, 
  confirmText, 
  cancelText, 
  success = false, 
  alert = false, 
  error = false }) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="dialog-title"
      classes={{paper: classes.paper}}
    >
      <center>
      <DialogTitle id="dialog-title"
        className={clsx(classes.title, success && classes.success, alert && classes.alert, error && classes.error)}
      >
        {title}
      </DialogTitle>
      </center>
   
      <Divider/>
      <DialogContent>
        <DialogContentText className={classes.body}>
          {body}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Grid container direction="row" justify="center" spacing={2}>
          <Grid item>
            <Button onClick={handleChange}
              className={clsx(classes.buttonOutlined, success && classes.success, alert && classes.alert, error && classes.error)} 
            >
              {confirmText}
            </Button>
          </Grid>
          <Grid item>
            <Button className={classes.button} onClick={handleClose}>
              {cancelText}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}

export default DialogCustom;